export const NON_ORGANIZATION_PATH_PREFIXES = new Set([
  "agent-training",
  "admin",
  "plans",
  "benchmarks",
  "getting-started",
  "home",
  "integrations",
  "marketplace",
  "settings",
  "shared",
  "signin",
  "signup",
  "sso-callback",
])
